import { useState } from "react";
import "../CarruselCreencias.css";
import biblia from "../assets/biblia.png";
import trinidad from "../assets/trinidad.png";
import alfaOmega from "../assets/alfa_omega.png";
import semilla from "../assets/semilla.png";
import espiritusanto from "../assets/espiritusanto.png";
import trompeta from "../assets/trompeta.png";
import iglesia from "../assets/iglesia.png";

import Versiculo from "../components/Versiculo";

import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

const slides = [
  {
    icono: biblia,
    titulo: "La Palabra de Dios",
    descripcion:
      "Creemos que la Biblia es la única inspirada por Dios, infalible y la máxima autoridad para la fe y la vida cristiana.",
    versiculo: "2 Timoteo 3:16",
  },

  {
    icono: trinidad,
    titulo: "La Trinidad",
    descripcion:
      "Creemos que hay un solo Dios que existe eternamente en tres personas: el Padre, el Hijo y el Espíritu Santo.",
    versiculo: "1 Corintios 8:6",
  },

  {
    icono: alfaOmega,
    titulo: "Jesucristo",
    descripcion:
      "Creemos en la deidad de nuestro Señor Jesucristo, en su nacimiento virginal, su vida sin pecado, sus milagros, su muerte vicaria, su resurrección corporal, su ascensión y su retorno con poder y gloria.",
    versiculo: "Isaías 7:14",
  },

  {
    icono: semilla,
    titulo: "La Salvación",
    descripcion:
      "Creemos que para la salvación de los hombres perdidos la regeneración por el Espíritu Santo es absolutamente indispensable.",
    versiculo: "Juan 3:3",
  },

  {
    icono: espiritusanto,
    titulo: "El Espíritu Santo",
    descripcion:
      "Creemos en el ministerio actual del Espíritu Santo, quien mora en el creyente y le da poder para vivir una vida santificada.",
    versiculo: "Hechos 2:38-39",
  },

  {
    icono: trompeta,
    titulo: "La Resurrección",
    descripcion:
      "Creemos en la resurrección de los salvos para vida eterna y de los perdidos para condenación eterna.",
    versiculo: "Juan 5:28-29",
  },

  {
    icono: iglesia,
    titulo: "La Iglesia",
    descripcion:
      "Creemos en la unidad espiritual de todos los creyentes en Cristo como un solo cuerpo.",
    versiculo: "1 Corintios 1:10",
  },
];
export default function CarruselCreencias() {
  const [activo, setActivo] = useState(0);

  const siguiente = () => {
    setActivo((prev) => (prev + 1) % slides.length);
  };

  const anterior = () => {
    setActivo((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const obtenerClase = (index) => {
    const total = slides.length;

    let posicion = index - activo;

    if (posicion > total / 2) posicion -= total;
    if (posicion < -total / 2) posicion += total;

    switch (posicion) {
      case 0:
        return "creencia-card active ";

      case -1:
        return "creencia-card left1";

      case -2:
        return "creencia-card left2";

      case -3:
        return "creencia-card left3";

      case 1:
        return "creencia-card right1";

      case 2:
        return "creencia-card right2";

      case 3:
        return "creencia-card right3";

      default:
        return "creencia-card hidden";
    }
  };

  return (
    <section className="creencias-section">
      <div className="creencias-container">
        <button className="arrow left-arrow" onClick={anterior}>
          <FaChevronLeft />
        </button>

        <div className="carousel">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={obtenerClase(index)}
              onClick={() => setActivo(index)}
            >
              <div className="icono">
                <img src={slide.icono} alt={slide.titulo} />
              </div>

              <h3>{slide.titulo}</h3>

              <p>{slide.descripcion}</p>

              <span style={{ color: "#9531a0" }}>
                                  <div style={{ textAlign: "center" }}>
                                    <Versiculo referencia={slide.versiculo}/>
                                  </div>
                                </span>
            </div>
          ))}
        </div>

        <button className="arrow right-arrow" onClick={siguiente}>
          <FaChevronRight />
        </button>
      </div>

      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            onClick={() => setActivo(index)}
            className={activo === index ? "dot active-dot" : "dot"}
          />
        ))}
      </div>
    </section>
  );
}
